import { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './LoginPage.module.css';

export default function ForgotPasswordPage() {
  const [email,   setEmail]   = useState('');
  const [sent,    setSent]    = useState(false);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      setSent(true);
    } catch {
      setError('Could not connect to server.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        {/* Was a div, so these pages had no h1 and a screen reader's heading
            list came back empty. */}
        <h1 className={styles.logo}>
          Gradiance<span className={styles.logoDot} aria-hidden="true">.</span>
        </h1>
        <p className={styles.tagline}>Reset your password</p>

        {sent ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }} role="status">
            <p style={{ color: 'var(--green)', fontWeight: 600, marginBottom: 12 }}>
              <span aria-hidden="true">✓ </span>Check your email
            </p>
            <p style={{ color: 'var(--txt-dim)', fontSize: 13 }}>
              If an account exists for {email}, you'll receive a reset link shortly.
              The link can be used once and expires in 2 hours.
            </p>
            <div style={{ marginTop: 20 }}>
              <Link to="/login" style={{ color: 'var(--gold)', fontSize: 13 }}>
                Back to login
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className={styles.form}>
            <p style={{ color: 'var(--txt-dim)', fontSize: 13, marginBottom: 8 }}>
              Enter your school email and we'll send you a reset link.
            </p>
            <div className={styles.field}>
              <label htmlFor="forgot-email">School Email</label>
              <input
                id="forgot-email"
                name="email"
                type="email"
                autoComplete="email"
                placeholder="you@uwec.edu"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
            {error && <div className={styles.error} role="alert">{error}</div>}
            <button
              type="submit"
              className={`btn-primary ${styles.submitBtn}`}
              disabled={loading}
              aria-busy={loading}
            >
              {loading ? 'Sending…' : 'Send Reset Link'}
            </button>
            <div className={styles.footer}>
              <Link to="/login">Back to login</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
